import {
    ClassicEditor,
    Essentials,
    Bold,
    Italic,
    Paragraph,
    Link,
    MediaEmbed,
    Heading,
    Undo,
    ImageBlock,
    GeneralHtmlSupport,
    List,
    ImageUpload,
    Image,
    ImageStyle,
    ImageToolbar,
    Mention,
} from 'ckeditor5';

import UploadAdapterPlugin from './plugins/UploadAdapterPlugin';
import CustomMentionPlugin from './plugins/CustomMentionPlugin';
import {getFeedItems, getFeedImages, customItemRenderer, customImageRenderer } from './plugins/MentionPlugin';
import MentionPlugin from './plugins/MentionPlugin';
import ZoomablePlugin from './plugins/ZoomablePlugin';
import ImageLazyLoadPlugin from './plugins/ImageLazyLoadPlugin';
import ClearText from './plugins/ClearTextPlugin';
import ReadMore from './plugins/readmore/ReadMore';

ClassicEditor.builtinPlugins = [
    Essentials,
    Bold,
    Italic,
    Link,
    Heading,
    Undo,
    List,
    Paragraph,
    Image,
    ImageBlock,
    ImageUpload,
    ImageStyle,
    ImageToolbar,
    MediaEmbed,
    GeneralHtmlSupport,
    UploadAdapterPlugin,
    CustomMentionPlugin,
    Mention,
    MentionPlugin,
    ZoomablePlugin,
    ImageLazyLoadPlugin,
    ClearText,
    ReadMore
];

ClassicEditor.defaultConfig = {
    licenseKey: 'GPL',
    toolbar: {
        items: [
            'link', 'uploadImage', 'zoomable', 'mediaEmbed','|',
            'bold', 'italic', '|',
            'heading', '|',
            'readMore', 'ClearText', '|',
            'undo', 'redo', '|',
        ]
    },
    image: {
        toolbar: [
            'imageStyle:alignLeft',
            'imageStyle:alignCenter',
            'imageStyle:alignRight',
        ],
        styles: {
            options: [
                {
                    name: 'alignCenter',
                    title: 'Centered image',
                    className: 'image-style-align-center',
                    modelElements: [ 'imageBlock' ],
                    isDefault: true
                },
                'alignLeft',
                'alignRight',
            ]
        },
    },
    link: {
        addTargetToExternalLinks: true,
        defaultProtocol: 'https://'
    },
    htmlSupport: {
        allow: [
            {
                name: 'a',
                attributes: true,
                classes: true,
                styles: true
            },
            {
                name: 'details',
                attributes: true,
                classes: true,
                styles: true
            },
            {
                name: 'summary',
                attributes: true,
                classes: true,
                styles: true
            }
        ]
    },
    mention: {
        dropdownLimit: 3,
        feeds: [
            {
                marker: '@',
                feed: getFeedItems,
                minimumCharacters: 3,
                itemRenderer: customItemRenderer
            },
            {
                marker: '#',
                feed: getFeedImages,
                minimumCharacters: 1,
                itemRenderer: customImageRenderer
            }
        ]
    },
    language: 'en',
};

if (typeof window !== 'undefined') {
    window.ClassicEditor = ClassicEditor;
}

export default ClassicEditor;
